import Checkbox from '@mui/material/Checkbox';
import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { usePipedriveStore, useSaleCompStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from '../../hooks/useCircleWithRadiusOnMap';
import useSaleCompsWithFocusArea from '../../hooks/useSaleCompsWithFocusArea';
import useSaleCompsWithGlobalFilters from '../../hooks/useSaleCompsWithGlobalFilters';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import RadiusDropdown from '../RadiusDropdown';
import SaleCompsGrid from '../saleComps/SaleCompsGrid';
import Spinner from '../spinners/Spinner';

function DealDetailsSaleCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const saleCompStore = useSaleCompStore();
    const pipedriveStore = usePipedriveStore();
    const deal = useMemo(() => computed(() => pipedriveStore.deals.find(d => d.id.toString() === id)!), [id]).get();
    const coordinates = useMemo(() => ({ latitude: deal.lat, longitude: deal.lon }), [deal]);
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(coordinates, radius)!;
    useCircleWithRadiusOnMap(coordinates, radius, visible, "DealDetailsSaleCompsTab");
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(
        useMemo(() => computed(() => saleCompStore.saleComps.filter(sc => circle.isPointInside(sc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(saleComps.length), [saleComps]);

    if (!visible)
        return null;

    return (
        <SaleCompsGrid
            saleComps={saleComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }, {
                titleStrings: ["TAG"],
                getValue: item => deal.saleCompIds.includes(item.id),
                getLabel: item => pipedriveStore.isDealsLoading.updating ? (
                    <Spinner />
                ) : (
                    <Checkbox
                        checked={deal.saleCompIds.includes(item.id)}
                        onChange={() => pipedriveStore.updateTaggedSaleComp(deal.id, item.id)}
                    />
                ),
                getStringLabel: item => deal.saleCompIds.includes(item.id) ? "True" : "False",
                onClick: () => { }, // to prevent onRowClick
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(DealDetailsSaleCompsTab);